"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    "in": 'in',
    option: 'Option',
    addOption: 'Add option'
  },
  es: {
    "in": 'en',
    option: 'Opción',
    addOption: 'Agregar opción'
  },
  fr: {
    "in": 'en',
    option: 'Option',
    addOption: 'Ajouter une option'
  },
  de: {
    "in": 'auf',
    option: 'Option',
    addOption: 'Möglichkeit hinzufügen'
  }
};
exports["default"] = _default;